<template>
  <div class="ct-compact-panel ct-form-panel">
    <div class="ct-panel-head ct-panel-head--title-only">
      <div class="ct-panel-head-copy">
        <h3 class="ct-panel-title-only">{{ panelTitle }}</h3>
        <p v-if="instructionText" class="ct-form-note">{{ instructionText }}</p>
      </div>
    </div>
    <div class="ct-panel-body ct-form-rows-wrap">
      <div
        class="ct-form-body-stage"
        :class="{ 'is-awaiting-age': awaitingAge }"
      >
        <div
          v-if="awaitingAge"
          class="ct-age-awaiting"
          aria-live="polite"
        >
          <div class="ct-age-awaiting-card">
            <span class="ct-age-awaiting-icon" aria-hidden="true">📋</span>
            <strong>Selecciona {{ test.ageLabel ? ageNoun : "la edad del evaluado" }}</strong>
            <span>
              El protocolo aparecerá aquí cuando elijas {{ ageNoun }} en el
              selector superior.
            </span>
          </div>
        </div>
        <!-- v-show (no v-if): mantener montado el <slot> para no destruir el
             keep-alive de los forms al pasar por estados sin edad elegida. -->
        <div v-show="!awaitingAge" class="ct-form-content">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestFormPanel",
  props: {
    test: { type: Object, required: true },
    panelTitle: { type: String, default: "" },
    instructionText: { type: String, default: "" },
    awaitingAge: { type: Boolean, default: false },
  },
  computed: {
    // El CARAS-R usa el selector de edad para el curso y el baremo.
    ageNoun() {
      return this.test.ageLabel ? this.test.ageLabel.toLowerCase() : "la edad";
    },
  },
};
</script>
